import { render, staticRenderFns } from "./MdtDropdownIcon.vue?vue&type=template&id=1221bd30&scoped=true"
import script from "./MdtDropdownIcon.vue?vue&type=script&lang=js"
export * from "./MdtDropdownIcon.vue?vue&type=script&lang=js"
import style0 from "./MdtDropdownIcon.vue?vue&type=style&index=0&id=1221bd30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1221bd30",
  null
  
)

export default component.exports